import React from 'react';

const icons = {
  market: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 4H5L5.6 7M5.6 7L7 15H18L20 7H5.6Z" />
      <circle cx="9" cy="19" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="17" cy="19" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  ),
  bank: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21H21" />
      <path d="M3 10H21" />
      <path d="M5 6L12 3L19 6" />
      <path d="M4 10V21" />
      <path d="M20 10V21" />
      <path d="M8 14V17" />
      <path d="M12 14V17" />
      <path d="M16 14V17" />
    </svg>
  ),
  profile: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M4.5 20C5.7 16.5 8.5 14.5 12 14.5C15.5 14.5 18.3 16.5 19.5 20" />
    </svg>
  ),
};

function Navigation({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'market', label: 'Маркет' },
    { id: 'bank', label: 'Банк' },
    { id: 'profile', label: 'Профиль' },
  ];

  return (
    <div className="bottom-nav">
      {tabs.map(t => (
        <button
          key={t.id}
          className={activeTab === t.id ? 'active' : ''}
          onClick={() => setActiveTab(t.id)}
        >
          <span className="bottom-nav-icon-wrap">{icons[t.id]}</span>
          <span>{t.label}</span>
        </button>
      ))}
    </div>
  );
}

export default Navigation;
